export default "__VITE_ASSET__C5odA9c4__"